<template>
  <div
    class="
      flex
      flex-col
      h-full
      px-4
      w-full
    "
  >
    <div class="
      flex
      flex-col
      items-center
      justify-center
      w-full
    ">
      <div class="
        bg-white
        box-shadow
        flex
        flex-col
        items-center
        justify-center
        mt-[148px]
        pb-6
        pt-2
        px-6
        rounded-lg
        w-[424px]
        sm:mt-7
        sm:w-full
      ">
        <h1 class="text-black font-light text-3xl mb-4">
          {{ title }}連結已逾期
        </h1>
        <p class="mb-16 text-gray-500 text-sm sm:mb-7">
          {{ description }}
        </p>
        <w-input
          v-model="email"
          :message="
            sendMailValidator$.email.$errors[0] && sendMailValidator$.email.$errors[0].$message
          "
          :show-error="
            !!(sendMailValidator$.email.$errors[0] && sendMailValidator$.email.$errors.length)
          "
          :show-success="!sendMailValidator$.email.invalid && sendMailValidator$.email.$dirty"
          class="mb-12 w-full"
          placeholder="電子郵件"
          type="email"
          @blur="sendMailValidator$.email.$touch()"
        />
        <w-button
          :disabled="
            loading || (sendMailValidator$.email.$invalid && sendMailValidator$.email.$dirty)
          "
          :loading="loading"
          :variant="$breakpoints.sm ? null : 'outline'"
          class="w-full mb-2"
          @click="resend"
        >
          {{ btnText }}
        </w-button>
        <p class="text-sm text-black">
          找不到驗證信？請查看您的垃圾郵件。
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import SendVerifyEmail from './SendVerifyEmail';

export default SendVerifyEmail;
</script>

<style lang="scss" scoped>
@import 'SendVerifyEmail';
</style>
